<template>
    <div>
        <v-card elevation="0" style="width: 100% !important">
            <v-card-title>
                <v-btn
                    depressed
                    @click="openCreate()"
                    color="green darken-2"
                    outlined
                    dark
                    small
                    class="d-flex justify-end"
                >
                    Crear Permisos
                    <v-icon right>mdi-lock-plus</v-icon>
                </v-btn>
            </v-card-title>
            <v-card elevation="0" class="pa-4">
                <v-data-table
                    :headers="headers"
                    :items="permissions"
                    class="elevation-0"
                    :search="search"
                    :footer-props="footer_props"
                >
                    <template v-slot:top>
                        <v-text-field
                            v-model="search"
                            label="Buscar"
                            class="mx-4"
                        ></v-text-field>
                    </template>
                    <template v-slot:item.Actions="{ item }">
                        <v-col md="12">
                            <div class="d-flex flex-row justify-space-between">
                                <v-btn
                                    v-if="hasSuperAdminPermission"
                                    fab
                                    @click="openEdit(item)"
                                    x-small
                                    color="orange"
                                    text
                                >
                                    <v-icon> mdi-pen </v-icon>
                                </v-btn>
                                <v-btn
                                    v-if="hasSuperAdminPermission"
                                    class="ml-1"
                                    fab
                                    @click="openDeleteDialog(item)"
                                    x-small
                                    color="red"
                                    text
                                >
                                    <v-icon> mdi-delete </v-icon>
                                </v-btn>
                            </div>
                        </v-col>
                    </template>
                </v-data-table>
            </v-card>
            <v-card-actions elevation="0" class="justify-end mt-n8">
                <v-btn
                    text
                    color="red"
                    @click="isOpenPermissionsSummary = false"
                >
                    Cerrar
                </v-btn>
            </v-card-actions>
        </v-card>
        <PermissionsForm />
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { clone, objectSnakeToCamelCase } from '@/util/libUtil.js';
import PermissionsForm from '@/components/DatabaseManagement/Auth/Permissions/PermissionsForm.vue';

export default {
    data: () => ({
        search: '',
        headers: [
            {
                text: 'name',
                value: 'name',
                align: 'start',
            },
            {
                text: 'content_type',
                value: 'content_type',
                align: 'start',
            },
            {
                text: 'codename',
                value: 'codename',
                align: 'start',
            },
            {
                text: 'Acciones',
                value: 'Actions',
                align: 'center',
                sortable: false,
                width: '10px',
            },
        ],
        footer_props: {
            disableItemsPerPage: true,
            itemsPerPageOptions: [10],
        },
    }),
    components: {
        PermissionsForm,
    },
    computed: {
        isOpenPermissionsSummary: {
            get() {
                return this.$store.state.databaseManagement.auth.permissions.isOpen;
            },
            set(value) {
                this.$store.commit('databaseManagement/auth/isOpenPermissionsSummary', value);
            },
        },
        ...mapState('databaseManagement/auth', {
            permissions: (state) => state.permissions.permissions,
        }),
        ...mapGetters('login', {
            hasSuperAdminPermission: 'hasSuperAdminPermission',
        }),
    },
    methods: {
        openEdit(item) {
            item.cookie = JSON.stringify(item.cookie);
            this.$store.commit('databaseManagement/auth/permissionsForm', item);
            this.$store.commit('databaseManagement/auth/permissionsType', 'EDIT');
            this.$store.commit('databaseManagement/auth/isOpenPermissionsView', true);
        },
        openCreate() {
            this.$store.commit('databaseManagement/auth/permissionsType', 'CREATE');
            this.$store.commit('databaseManagement/auth/isOpenPermissionsView', true);
        },
        openDeleteDialog(item) {
            let deleteObj = {
                toDeleteId: item.id,
                toDeleteType: 'PERMISSIONS',
                isOpenDeleteDialog: true,
            };

            this.$store.commit('util/deleteDialog', clone(deleteObj));
        },
        ...mapActions('databaseManagement/auth', ['getPermissions']),
    },
    watch: {},
};
</script>

<style>
</style>







